import {RawLocation, Route} from "vue-router";

/** ページの権限 (肯定) */
export type PositivePermissionType =
    'admin' | // 事業者管理権限
    'contract' | // 取引管理権限
    'implementation' | // 実装管理権限
    'dictionary' | // 辞書管理権限
    'platformOwner' | // 共通辞書管理権限
    'componentOwner'; // 外部辞書管理権限

/** ページの権限 (否定) */
export type NegativePermissionType =
    '!admin' | // 事業者管理権限
    '!contract' | // 取引管理権限
    '!implementation' | // 実装管理権限
    '!dictionary' | // 辞書管理権限
    '!platformOwner' | // 共通辞書管理権限
    '!componentOwner'; // 外部辞書管理権限

/** すべてのページの権限 */
export type PermissionType = PositivePermissionType | NegativePermissionType;

/**
 * ルートのメタ情報
 */
export interface Meta {
  /** 画面のラベル */
  label: string;

  /** 親画面の RouteConfig#name */
  parent?: string;

  /**
   * ページを開く為に、指定された権限のすべてが必要
   * 無指定 (undefined or []) の場合、すべてのユーザーが利用可能となります
   */
  permissions?: PermissionType[];

  /**
   * パーミッション由来でフォールバックする場合のロケーション
   */
  fallback?: string | RawLocation;

  /**
   * その他オプション
   */
  [extraProps: string]: any;
}

/**
 * 安全にルートのメタ情報にアクセスします
 *
 * @param route ルート
 * @param considerNestedView ネストされたルートを考慮する場合 true そうでない場合 false
 */
export function safeMeta(route: Route, considerNestedView = false): Partial<Meta> {
  const meta = {} as Partial<Meta>;
  route.matched.forEach(r => {
    Object.assign(meta, r.meta);
    if(considerNestedView && r.parent?.name) {
      meta.parent = r.parent.name;
    }
  });
  return meta;
}

/**
 * 安全にルート名を取得します
 *
 * @param route ルート
 */
export function safeName(route: Route): string | undefined {
  for(let i = route.matched.length - 1; i >= 0; i--) {
    const matched = route.matched[i];
    if(matched.name) {
      return matched.name;
    }
  }
  return undefined;
}
